<template>
  <div class="placed-image" :class="{square: square, fill: fill}">
    <img :src="imgUrl" />
  </div>
</template>

<script>
export default {
  props: {
    url: String,
    square: Boolean,
    fill: Boolean
  },
  computed: {
    imgUrl () {
      return this.$k.imagebase + 'mediastore/' + this.url
    }
  }

}
</script>

<style scoped>
.placed-image img{
  width:100%;
  display:block;
}

.placed-image.square{
  overflow:hidden;
  position: relative;
  min-width:100px;
}

.placed-image.fill{
  width:100%;
  height:100%;
}

.placed-image.fill img{
  min-height:100%;
  object-fit:cover;
  object-position: center center;
}



</style>
